import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Routes from './routes';
import { AuthProvider } from './contexts/AuthContext';

import Colors from './entities/colors';
import { NavigationProvider } from './contexts/NavigationContext';

const theme = createTheme({
  typography: {
    fontFamily: 'Gilroy',
  },
  palette: {
    mode: 'dark',
    primary: {
      main: Colors.Y100,
      '100': Colors.Y100,
      '200': Colors.Y200,
      '300': Colors.Y300,
      '400': Colors.Y400,
    },
    secondary: {
      main: Colors.G400,
      '100': Colors.G100,
      '200': Colors.G200,
      '300': Colors.G300,
      '400': Colors.G400,
    },
    neutral: {
      '100': Colors.N100,
      '200': Colors.N200,
      '300': Colors.N300,
      '400': Colors.N400,
      '500': Colors.N500,
      '600': Colors.N600,
    },
  },
});

const App = () => (
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <SnackbarProvider
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          autoHideDuration={10000}
          resumeHideDuration={0}
          preventDuplicate
        >
          <NavigationProvider>
            <Routes />
          </NavigationProvider>
        </SnackbarProvider>
      </AuthProvider>
    </ThemeProvider>
  </BrowserRouter>
);

export default App;
